import Vue from 'vue'
import Router from 'vue-router'
import mainRouter from './mainRouter'
Vue.use(Router)
const router = new Router({
    mode:'history',
    routes: [...mainRouter],
    scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router

